"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesList = void 0;
var GamesList = /** @class */ (function (_super) {
    __extends(GamesList, _super);
    function GamesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Sorting is already being done in the backend.
         */
        _this.getDateStartSorted = function () { return _this; };
        return _this;
    }
    Object.defineProperty(GamesList.prototype, "isFeatured", {
        get: function () {
            return this[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamesList.prototype, "topList", {
        get: function () {
            return this.slice(1);
        },
        enumerable: false,
        configurable: true
    });
    return GamesList;
}(Array));
exports.GamesList = GamesList;
//# sourceMappingURL=GamesList.js.map